<template>
    <div :id="componentId"
         :ref="componentId"
         class="helpMenu">
        <div class="helpMenuIcon" @click="toggleMenu()">
            <slot name="icon"></slot>
        </div>
        <div class="helpMenuContent" v-if="showHelpMenu"
             v-iron-source-click-outside="{
                    handler: 'closeMenu',
                    exclude: [componentId]
                 }">
            <slot name="content"></slot>
        </div>
    </div>
</template>

<script>
import ironSourceClickOutside from 'directives/IronSourceClickOutside';

export default {
    name: 'helpMenu',
    props: {
        uniqueId: String
    },
    data() {
        return {
            showHelpMenu: false
        };
    },
    methods: {
        closeMenu() {
            this.showHelpMenu = false;
            this.$emit('toggleHelpMenu', this.showHelpMenu);
        },
        toggleMenu() {
            this.showHelpMenu = !this.showHelpMenu;
            this.$emit('toggleHelpMenu', this.showHelpMenu);
        }
    },
    computed: {
        componentId() {
            return `uniqueHelpMenu${this.uniqueId || Math.random().toString().substring(2, 7)}`;
        }
    },
    directives: {
        ironSourceClickOutside
    }
};
</script>

<style scoped lang="scss">
    @import "~styles/styleGuide";

    .helpMenuContent {
        $width: 230px;
        position: absolute;
        @include applicationLayer;
        box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);
        border-radius: 4px;
        padding: 5px 16px 4px 16px;
        background-color: $white;
        right: 0;
        width: $width;
    }

    .helpMenuIcon {
        cursor: default;
        &:hover {
            cursor: pointer;
        }
    }

    .helpMenu {
        position: relative;
        top: 3px;
    }
</style>
